import React from "react";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import TableContainer from "@mui/material/TableContainer";
import { Paper } from "@mui/material";
import ToolBar from "./ToolBar";
import Table from "@mui/material/Table";

import { useState } from "react";
import LinearProgress from "@mui/material/LinearProgress";

function sortByThenBy(a, b, thenBy, order) {
  if (order === "asc") {
    if (!a && !b) return thenBy || 0;
    if (!a) return -1;
    if (!b) return +1;

    return a.localeCompare(b) || thenBy || 0;
  } else if (order === "desc") {
    if (!a && !b) return thenBy || 0;
    if (!a) return +1;
    if (!b) return -1;

    return b.localeCompare(a) || thenBy || 0;
  }
}

function DataTable(props) {
  const { name, columns, options } = props;

  const [searchField, setSearchField] = useState("");
  const [displayColumns, setDisplayColumns] = useState([...columns] || []);
  const [sortBy, setSortBy] = useState([]);
  const [rowFilters, setRowfilters] = useState([]);

  const sorted = () => {
    const sortFunc = (a, b) => {
      let func = null;

      [...sortBy].reverse().forEach((item) => {
        func = `sortByThenBy(a["${item.column}"], b["${item.column}"], ${func}, "${item.order}")`;
      });

      return eval(func);
    };

    return [...props.rows].sort((a, b) => sortFunc(a, b));
  };

  const filteredColumns = displayColumns.filter((item) => {
    if (item.hasOwnProperty("display")) {
      return item.display;
    } else {
      return true;
    }
  });

  const filteredRows = sorted().filter((row) => {
    const array = Object.values(row).map((item) =>
      item?.toLowerCase?.()?.includes(searchField.toLowerCase?.())
    );

    return (
      rowFilters
        .map((item) =>
          item.values.map((item) => item.title).includes(row[item.column])
        )
        .every((item) => item === true) && array.includes(true)
    );
  });

  return (
    <>
      {options?.toolbar !== false && (
        <ToolBar
          searchField={searchField}
          setSearchField={setSearchField}
          name={name}
          rows={props.rows}
          columns={columns}
          displayColumns={displayColumns}
          setDisplayColumns={setDisplayColumns}
          rowFilters={rowFilters}
          setRowfilters={setRowfilters}
        />
      )}
      <Paper
        sx={{
          height: "calc(100% - 7px)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
        elevation={3}
        square
      >
        {options?.isLoading && <LinearProgress />}
        <TableContainer sx={{ height: "100%"}}>
          <Table
            size="small"
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Header
              options={options}
              sortBy={sortBy}
              setSortBy={setSortBy}
              columns={filteredColumns}
            />
            <Body
              rows={filteredRows}
              filteredColumns={filteredColumns}
              columns={columns}
              options={options}
            />
          </Table>
        </TableContainer>
       {options.footer && <Footer options={options} />}
      </Paper>
    </>
  );
}

export default DataTable;
